import { useSignupData } from '../signup-data/useSignupData';
import { Data } from 'signup-constants/signupData/Data';
import { useLandingPage } from './useLandingPage';
import { Step } from 'signup-constants/Step';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { SignupDataInput } from '../signup-data/SignupDataInput';
import { Button } from 'foundations-components/transitional/components/Button';
import { getLandingPageButton } from './getLandingPageText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useWorkEmailLabel } from './useWorkEmailLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STEP_KEY = Step.LandingPage;
export const EmailDataInput = () => {
  const {
    isValid
  } = useSignupData(Data.Email);
  const {
    chooseEmailSignUp
  } = useLandingPage(STEP_KEY);
  const {
    labelOverride
  } = useWorkEmailLabel();
  const onSubmit = evt => {
    if (evt) evt.preventDefault();
    const isReadyToSubmit = isValid && chooseEmailSignUp;
    if (isReadyToSubmit) {
      chooseEmailSignUp();
    }
  };
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "200",
    children: /*#__PURE__*/_jsx("form", {
      action: "blue-button-in-all-fields-ios",
      onSubmit: onSubmit,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        gap: "400",
        inlineSize: "100%",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(View, {
          inlineSize: "250px",
          paddingInlineStart: "400",
          children: /*#__PURE__*/_jsx(SignupDataInput, {
            dataKey: Data.Email,
            height: "",
            inputMode: "email",
            labelOverride: labelOverride,
            shouldShowPlaceholder: true,
            shouldTrimData: true,
            updateInputStyle: true
          })
        }), /*#__PURE__*/_jsxs(View, {
          marginBlockStart: labelOverride ? '900' : '800',
          paddingInlineEnd: "400",
          children: [/*#__PURE__*/_jsx(Spacer, {
            space: labelOverride ? '100' : '50'
          }), /*#__PURE__*/_jsx(Button, {
            "data-selenium": `${STEP_KEY}_button`,
            disabled: !isValid,
            label: getLandingPageButton(),
            type: "submit",
            use: "primary",
            onClick: chooseEmailSignUp,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `views.${Step.LandingPage}.nextButtonLabel.verifyEmail`
            })
          })]
        })]
      })
    })
  });
};